{
  "title": "Pulpit",
  "greeting": "Dzień dobry, {{name}}",
  "greetingAnonymous": "Dzień dobry",
  "scope": {
    "onlyMine": "Tylko moje",
    "workspaceTrigger": "Zmień workspace",
    "teamTrigger": "Zmień zespół",
    "allWorkspaces": "Wszystkie workspace’y",
    "allTeams": "Wszystkie zespoły",
    "searchPlaceholder": "Szukaj…",
    "pickerEmpty": "Nic nie znaleziono"
  },
  "summary": {
    "mine": "{{attention}} spraw czeka na ciebie · {{shoots}} twoich zdjęć w ciągu {{days}} dni",
    "workspace": "{{attention}} spraw wymaga uwagi · {{shoots}} zdjęć w ciągu {{days}} dni",
    "organization": "{{attention}} spraw wymaga uwagi w organizacji · {{shoots}} zdjęć w ciągu {{days}} dni",
    "team": "{{attention}} spraw wymaga uwagi w tym zespole · {{shoots}} zdjęć w ciągu {{days}} dni",
    "total": "Otwarte sprawy"
  },
  "sections": {
    "attention": "Wymaga uwagi",
    "attentionHint": "Najpilniejsze na górze; wiersze znikają, gdy sprawa jest załatwiona",
    "timeline": "Najbliższe {{days}} dni",
    "timelineHint": "Daty zdjęć tor po torze; najedź na pasek po ekipę i status",
    "workspaces": "Workspace’y",
    "workspacesHint": "Gdzie jest teraz praca i ryzyko",
    "summaryHint": "Każdy rodzaj otwiera kolejkę na swojej zakładce",
    "later": "Dalej w tym okresie",
    "laterHint": "Zdjęcia po jutrze"
  },
  "shoot": {
    "open": "Otwórz produkcję",
    "untitled": "Produkcja bez nazwy",
    "crewMeter": "Obsadzona ekipa",
    "callsheetMeter": "Callsheet",
    "callsheet_shared": "Wysłany",
    "callsheet_building": "W przygotowaniu",
    "callsheet_missing": "Nie rozpoczęty",
    "crewOpen": "Wciąż wolne",
    "crewBooked": "Zabookowani",
    "crewUnnamedRole": "Rola bez nazwy",
    "crewMore": "i jeszcze {{count}}"
  },
  "status": {
    "active": "Zdjęcia trwają",
    "ready": "Gotowa",
    "resourcing": "Obsadzanie",
    "alert": "Zagrożona",
    "draft": "Brak ról",
    "complete": "Zakończona"
  },
  "when": {
    "today": "Dziś",
    "tomorrow": "Jutro",
    "inDays_one": "za {{count}} dzień",
    "inDays_few": "za {{count}} dni",
    "inDays_many": "za {{count}} dni",
    "inDays_other": "za {{count}} dnia"
  },
  "stats": {
    "shoots": "Zdjęcia",
    "shootsHint": "w ciągu najbliższych {{days}} dni",
    "rolesFilled": "Obsadzone role",
    "rolesFilledHint": "{{booked}} z {{total}} ról",
    "pencils": "Pencile do potwierdzenia",
    "pencilsHint": "rezerwacje w ciągu {{days}} dni",
    "attention": "Wymaga uwagi",
    "attentionHint": "spraw czeka na reakcję",
    "availability": "Pytania o dostępność",
    "availabilityHint": "wysłane, wciąż bez odpowiedzi"
  },
  "filters": {
    "all": "Wszystko",
    "resourcing": "Obsadzanie",
    "availability": "Dostępność",
    "callsheets": "Callsheety",
    "bookings": "Bookingi"
  },
  "attention": {
    "ariaLabel": "Sprawy wymagające uwagi",
    "empty": "Nic tu nie czeka.",
    "rolesUnfilled": {
      "title_one": "{{count}} nieobsadzona rola w {{production}}",
      "title_few": "{{count}} nieobsadzone role w {{production}}",
      "title_many": "{{count}} nieobsadzonych ról w {{production}}",
      "title_other": "{{count}} nieobsadzonej roli w {{production}}",
      "description": "Zdjęcia startują {{date}}",
      "action": "Znajdź ekipę"
    },
    "callsheetMissing": {
      "title": "Brak callsheetu dla {{production}}",
      "description_one": "{{count}} osoba w ekipie zabookowana",
      "description_few": "{{count}} osoby w ekipie zabookowane",
      "description_many": "{{count}} osób w ekipie zabookowanych",
      "description_other": "{{count}} osoby w ekipie zabookowane",
      "action": "Otwórz"
    },
    "callsheetBuilding": {
      "title": "Callsheet dla {{production}} nie został wysłany",
      "description": "Odbiorcy nie mają szczegółów wezwania",
      "action": "Otwórz"
    },
    "availability": {
      "title": "{{resource}} jeszcze nie odpowiedział(a)",
      "someone": "Ten zasób",
      "description": "Pytanie o dostępność na {{range}}",
      "due_one": "czeka {{count}} dzień",
      "due_few": "czeka {{count}} dni",
      "due_many": "czeka {{count}} dni",
      "due_other": "czeka {{count}} dnia",
      "dueToday": "wysłane dzisiaj",
      "action": "Otwórz zasób"
    },
    "pencils": {
      "title_one": "{{count}} pencil wymaga potwierdzenia",
      "title_few": "{{count}} pencile wymagają potwierdzenia",
      "title_many": "{{count}} pencili wymaga potwierdzenia",
      "title_other": "{{count}} pencila wymaga potwierdzenia",
      "description": "Rezerwacje w ciągu najbliższych {{days}} dni",
      "due": "To okno",
      "action": "Otwórz bookingi"
    }
  },
  "timeline": {
    "empty": "Brak zdjęć w tym okresie.",
    "unassigned": "Bez zespołu",
    "crew": "Obsadzona ekipa {{booked}} / {{total}}",
    "demandBooked_one": "{{count}} osoba obsadzona",
    "demandBooked_few": "{{count}} osoby obsadzone",
    "demandBooked_many": "{{count}} osób obsadzonych",
    "demandBooked_other": "{{count}} osoby obsadzone",
    "demandUnfilled_one": "{{count}} nieobsadzona rola",
    "demandUnfilled_few": "{{count}} nieobsadzone role",
    "demandUnfilled_many": "{{count}} nieobsadzonych ról",
    "demandUnfilled_other": "{{count}} nieobsadzonej roli",
    "legend": {
      "active": "Zdjęcia trwają",
      "ready": "Gotowa",
      "resourcing": "Obsadzanie",
      "alert": "Zagrożona"
    },
    "openRoles": "wolne: {{count}}"
  },
  "workspaces": {
    "shoots_one": "{{count}} zdjęcie w ciągu {{days}} dni",
    "shoots_few": "{{count}} zdjęcia w ciągu {{days}} dni",
    "shoots_many": "{{count}} zdjęć w ciągu {{days}} dni",
    "shoots_other": "{{count}} zdjęcia w ciągu {{days}} dni",
    "rolesFilled": "obsadzonych ról",
    "attention": "{{value}} do ogarnięcia",
    "noAttention": "Pod kontrolą",
    "open": "Otwórz",
    "emptyTitle": "Brak workspace’ów",
    "empty": "Ta organizacja nie ma jeszcze workspace’ów."
  },
  "loadError": "Nie udało się wczytać pulpitu.",
  "demo": {
    "toggle": "Zobacz potencjał dashboardu",
    "bannerTitle": "Oglądasz przykładowe dane",
    "bannerMessage": "Wymyślone, intensywne dwa tygodnie — tak wygląda ten dashboard, gdy Twoje zdjęcia, ekipa i callsheety są w Atellio. Linki są wyłączone.",
    "exit": "Wróć do moich danych"
  },
  "view": {
    "trigger": "Widok: {{view}}",
    "menuLabel": "Widok dashboardu",
    "names": {
      "today": "Dziś",
      "plan": "Plan",
      "table": "Tabela",
      "overview": "Przegląd"
    },
    "descriptions": {
      "today": "Najpierw to, co czeka na Ciebie, potem najbliższe zdjęcia",
      "plan": "Kto i kiedy ma zdjęcia w całym okresie oraz ekipa na dzień",
      "table": "Wszystkie zdjęcia z okresu na jednej liście",
      "overview": "Liczby i najbliższe zdjęcia w skrócie"
    },
    "answers": {
      "today": "Obsadzam ekipę i pilnuję potwierdzeń",
      "plan": "Planuję, kto i kiedy pracuje",
      "table": "Prowadzę dużo produkcji naraz",
      "overview": "Sprawdzam, czy wszystko idzie zgodnie z planem"
    },
    "question": "Co robisz w Atellio najczęściej?",
    "questionHint": "Ułożymy pod to dashboard. Widok zmienisz w każdej chwili.",
    "skip": "Pomiń",
    "pickedHint": "Widok: {{view}}. Zmienisz go w każdej chwili pod „Widok” w prawym górnym rogu.",
    "pickedHintDismiss": "OK"
  },
  "table": {
    "title": "Zdjęcia w najbliższych {{days}} dniach",
    "hint": "Od najwcześniejszych; produkcję otworzysz z jej nazwy",
    "production": "Produkcja",
    "lane": "Zespół",
    "laneWorkspace": "Workspace",
    "dates": "Daty",
    "status": "Status",
    "crew": "Ekipa",
    "callsheet": "Callsheet",
    "issues": "Problemy",
    "filterAll": "Wszystkie",
    "filterWithIssues": "Z problemami",
    "filterThisWeek": "Ten tydzień",
    "issueCount_one": "{{count}} problem",
    "issueCount_few": "{{count}} problemy",
    "issueCount_many": "{{count}} problemów",
    "issueCount_other": "{{count}} problemu"
  },
  "day": {
    "hint": "Ekipa: {{count}} · nieobsadzone: {{unfilled}} · wybierz inny dzień powyżej",
    "empty": "Tego dnia nie ma zdjęć."
  },
  "overview": {
    "today": "Dziś",
    "todayHeadline_one": "Na planie: {{count}}",
    "todayHeadline_few": "Na planie: {{count}}",
    "todayHeadline_many": "Na planie: {{count}}",
    "todayHeadline_other": "Na planie: {{count}}",
    "todayEmpty": "Dziś nic nie jest na planie",
    "atRisk": "Zagrożone",
    "ready": "Ekipa obsadzona, nic na Ciebie nie czeka.",
    "laterEmpty": "Nic więcej w tym okresie."
  },
  "agenda": {
    "stripLabel": "Dni w tym okresie",
    "stripCaption": "Każda kropka to produkcja na planie · pomarańczowa jest zagrożona",
    "dayShoots_one": "na planie: {{count}}",
    "dayShoots_few": "na planie: {{count}}",
    "dayShoots_many": "na planie: {{count}}",
    "dayShoots_other": "na planie: {{count}}",
    "dayAtRisk": "zagrożone: {{count}}",
    "laterOpen_one": "Dalej w tym okresie: jeszcze {{count}}, z otwartymi sprawami: {{open}}.",
    "laterOpen_few": "Dalej w tym okresie: jeszcze {{count}}, z otwartymi sprawami: {{open}}.",
    "laterOpen_many": "Dalej w tym okresie: jeszcze {{count}}, z otwartymi sprawami: {{open}}.",
    "laterOpen_other": "Dalej w tym okresie: jeszcze {{count}}, z otwartymi sprawami: {{open}}.",
    "laterReady_one": "Dalej w tym okresie: jeszcze {{count}}, wszystko zgodnie z planem.",
    "laterReady_few": "Dalej w tym okresie: jeszcze {{count}}, wszystko zgodnie z planem.",
    "laterReady_many": "Dalej w tym okresie: jeszcze {{count}}, wszystko zgodnie z planem.",
    "laterReady_other": "Dalej w tym okresie: jeszcze {{count}}, wszystko zgodnie z planem.",
    "seePlan": "Zobacz cały plan",
    "title": "Co dalej",
    "onSet": "Dziś na planie",
    "onSetShoots_one": "{{count}} produkcja",
    "onSetShoots_few": "{{count}} produkcje",
    "onSetShoots_many": "{{count}} produkcji",
    "onSetShoots_other": "{{count}} produkcji",
    "onSetPeople_one": "{{count}} osoba",
    "onSetPeople_few": "{{count}} osoby",
    "onSetPeople_many": "{{count}} osób",
    "onSetPeople_other": "{{count}} osoby",
    "onSetReady": "wszystko gotowe",
    "onSetOpen_one": "{{count}} czegoś potrzebuje",
    "onSetOpen_few": "{{count}} czegoś potrzebują",
    "onSetOpen_many": "{{count}} czegoś potrzebuje",
    "onSetOpen_other": "{{count}} czegoś potrzebuje",
    "noCrew": "Ekipa jeszcze nie zaplanowana",
    "onSetMore_one": "Jeszcze {{count}} produkcja na planie dziś",
    "onSetMore_few": "Jeszcze {{count}} produkcje na planie dziś",
    "onSetMore_many": "Jeszcze {{count}} produkcji na planie dziś",
    "onSetMore_other": "Jeszcze {{count}} produkcji na planie dziś"
  },
  "create": {
    "production": "Nowa produkcja"
  }
}
